import _ from '../../utils/underscore';
import Logger from '../../../src/utils/logger';
import {IFreePlayVoucherData} from "../../../../common/interfaces/free-play/free-play-voucher-data.interface";



export class FreePlayVoucher {

    constructor(voucher: IFreePlayVoucherData) {
        this._voucher = voucher;
    }

    private _voucher: IFreePlayVoucherData;

    private _logger = new Logger('FreePlayVoucher');

    isThirdPartyVoucher(): boolean {
        return this._voucher && !_.isNullOrUndefined(this._voucher.CompanyID);
    }

    isValid(checkExpirationDate: boolean) {
        if (!this._voucher) {
            this._logger.warn(`Invalid voucher object given`);
            return false;
        }
        if (!this._voucher.ID) {
            this._logger.warn(`Voucher ID ${this._voucher.ID} is invalid`);
            return false;
        }

        if (checkExpirationDate) {
            if (!this._voucher.ExpirationDate) {
                this._logger.warn(`Expiration date does not exist. Voucher ${this._voucher.ID}`);
                return false;
            }
            if (!(this._voucher.ExpirationDate instanceof Date)) {
                this._logger.warn(`Expiration date is not a Date instance. Voucher ${this._voucher.ID}`);
                return false;
            }
            if (!_.isNumber(this._voucher.ExpirationDate.getTime()))
            {
                this._logger.warn(`Expiration date is invalid. Voucher ${this._voucher.ID}`);
                return false;
            }
        }

        return true;
    }

    static isThirdPartyVoucher(toCheck: IFreePlayVoucherData): boolean {
        return new FreePlayVoucher(toCheck).isThirdPartyVoucher();
    }

    static isValid(toCheck: IFreePlayVoucherData, checkExpirationDate: boolean) {
        return new FreePlayVoucher(toCheck).isValid(checkExpirationDate);
    }
}
